module.exports = __webpack_public_path__ + "img/book.6e7f6c36.svg";